module.exports = __webpack_public_path__ + "static/qr_@2x-f1774fa911ab5b019dd3909d7d3525e4.png";